require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-financial-education-fraud-protection.json") })
        }
      }, "path---es-financial-education-fraud-protection");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-financial-education-fraud-protection!./.cache/json/es-financial-education-fraud-protection.json
// module id = 2492
// module chunks = 231608221292675